<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '../../utils';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
    }>();
</script>

<template>
    <div
        data-slot="dialog-header"
        :class="cn('py-4', props.class)"
    >
        <slot />
    </div>
</template>
